module.exports = __webpack_public_path__ + "assets/img/couponBanner_2.8a5a73a0.png";